import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { operator } from 'constants/pricing';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const PricingOperatorSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [defaultValue, setDefaultValue] = useState('');
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = operator.find((category) => category === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`ruleset.${defaultVal?.toLowerCase()}`));
      } else {
        setDefaultValue('');
      }
    }
  }, [value, operator]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      id="pricing-operator"
      inputValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setDefaultValue(val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      options={operator.filter((val) => omitFields.indexOf(val))}
      getOptionLabel={(option) => i18n.t(`ruleset.${option?.toLowerCase()}`)}
      getOptionSelected={(option, value) => option === value || ''}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
    />
  );
};

PricingOperatorSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  omitFields: PropTypes.array,
};

PricingOperatorSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Operator',
  omitFields: [],
};

export default PricingOperatorSelect;
